<template>
  <div>
    <document-manager></document-manager>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import DocumentManager from "./DocumentManager/DocumentManager"


export default {
  mixins: [ColorMixin],
  components:{
    DocumentManager
  },
}
</script>

<style>
</style>